setLanguageProcessing